import { render, staticRenderFns } from "./SelectAward.vue?vue&type=template&id=12c0cac4"
import script from "./SelectAward.vue?vue&type=script&lang=js"
export * from "./SelectAward.vue?vue&type=script&lang=js"
import style0 from "./SelectAward.vue?vue&type=style&index=0&id=12c0cac4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports